import { getFormattingLocale } from "shared/lib/locale/formattingLocale"

export function formatNumber({
  number,
  options,
  locale
}: {
  number: number
  options?: Intl.NumberFormatOptions | undefined
  locale?: string
}): string {
  const minimumFractionDigits = options?.minimumFractionDigits ?? 0

  return new Intl.NumberFormat(getFormattingLocale(locale), {
    minimumFractionDigits,
    // Intl throws when the maximum ends up below the minimum, which happens as
    // soon as a caller passes only a minimum and we default the maximum to 0.
    maximumFractionDigits: Math.max(
      options?.maximumFractionDigits ?? 0,
      minimumFractionDigits
    )
  }).format(number)
}

export function formatPrice({
  price,
  currency,
  locale,
  prefix
}: {
  price: number | null
  currency: string
  locale?: string
  prefix?: string | null
}): string {
  if (price === null) {
    return "-"
  }

  const formattedPriceText = `${prefix || ""} ${formatNumber({
    number: price,
    options: {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currency
    },
    locale
  })} ${currency}`.trim()

  return formattedPriceText
}
